import { WizardStep } from '../../../types/generatedTypes';

// WizardStep constants matching backend IntEnum (1-indexed)
export const WIZARD_STEPS = {
  UPLOAD_FILES: 1 as WizardStep,
  CONFIGURE_MAPPING: 2 as WizardStep,
  LINK_ACCOUNTS: 3 as WizardStep,
  LINK_INSTRUMENTS: 4 as WizardStep,
  LINK_OTC: 5 as WizardStep,
  REVIEW_AND_UPLOAD: 6 as WizardStep,
  POSITIONS_MONITORING: 7 as WizardStep,
} as const;

export const TOTAL_STEPS = Object.keys(WIZARD_STEPS).length;
